"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnquiryDetailsListingInspectionDtoInspectionTypeEnum = void 0;
exports.instanceOfEnquiryDetailsListingInspectionDto = instanceOfEnquiryDetailsListingInspectionDto;
exports.EnquiryDetailsListingInspectionDtoFromJSON = EnquiryDetailsListingInspectionDtoFromJSON;
exports.EnquiryDetailsListingInspectionDtoFromJSONTyped = EnquiryDetailsListingInspectionDtoFromJSONTyped;
exports.EnquiryDetailsListingInspectionDtoToJSON = EnquiryDetailsListingInspectionDtoToJSON;
exports.EnquiryDetailsListingInspectionDtoToJSONTyped = EnquiryDetailsListingInspectionDtoToJSONTyped;
/**
 * @export
 */
exports.EnquiryDetailsListingInspectionDtoInspectionTypeEnum = {
    Private: 'private',
    Open: 'open'
};
/**
 * Check if a given object implements the EnquiryDetailsListingInspectionDto interface.
 */
function instanceOfEnquiryDetailsListingInspectionDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('inspectionType' in value) || value['inspectionType'] === undefined)
        return false;
    if (!('isCancelled' in value) || value['isCancelled'] === undefined)
        return false;
    return true;
}
function EnquiryDetailsListingInspectionDtoFromJSON(json) {
    return EnquiryDetailsListingInspectionDtoFromJSONTyped(json, false);
}
function EnquiryDetailsListingInspectionDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'inspectionStartTime': json['inspectionStartTime'] == null ? undefined : json['inspectionStartTime'],
        'inspectionEndTime': json['inspectionEndTime'] == null ? undefined : json['inspectionEndTime'],
        'inspectionType': json['inspectionType'],
        'isCancelled': json['isCancelled'],
        'cancellationReason': json['cancellationReason'] == null ? undefined : json['cancellationReason'],
    };
}
function EnquiryDetailsListingInspectionDtoToJSON(json) {
    return EnquiryDetailsListingInspectionDtoToJSONTyped(json, false);
}
function EnquiryDetailsListingInspectionDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'inspectionStartTime': value['inspectionStartTime'],
        'inspectionEndTime': value['inspectionEndTime'],
        'inspectionType': value['inspectionType'],
        'isCancelled': value['isCancelled'],
        'cancellationReason': value['cancellationReason'],
    };
}
